import React, { useEffect, useState } from "react";
import { getAllAdminDealers, getAllAdminUsers, postComunication, postPushBroadcast, TConcessionaria, TUser } from "../../../services";
import { useToastStore } from "../../../stores";
import { Option } from "../../../components/dropdown/Dropdown";
import { TagActiveLabel } from "../../enums";

export const usePushEmail = () => {

    const [title, setTitle] = useState<string>("");
    const [toEmail, setToEmail] = useState<any[]>([]); 
    const [name, setName] = useState<any[]>([]); 
    const [message, setMessage] = useState<string>("");
    const [greeting, setGreeting] = useState<string>("");
    const [farewell, setFarewell] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [users, setUsers] = useState<TUser[]>([]);
    const [dealers, setDealers] = useState<TConcessionaria[]>([]);
    const { setToast } = useToastStore();
    const [timeLeft, setTimeLeft] = useState(0); 
    const [isSending, setIsSending] = useState(false); 
    const [emailProgress, setEmailProgress] = useState(0);
    const [emailsSentCount, setEmailsSentCount] = useState(0);
    const [totalRecipients, setTotalRecipients] = useState(0);


    
   
    const [userType, setUserType] = useState<'revendas' | 'concessionarias'>('revendas');
    const [notificationType, setNotificationType] = useState<'enviarPush' | 'enviarEmail'>('enviarPush');
    const [userTypeStatus, setUserTypeStatus] = useState<'todos' | 'ativos' | 'inativos'>('todos'); 

   

    const userTypeStatusOptions: Option[] = [
        { value: 'todos', label: 'Todos' },
        { value: 'ativos', label:  'Ativos'},
        { value: 'inativos', label: 'Inativos' },
    ];
    

    const userTypeOptions: Option[] = [
        { value: 'revendas', label: 'Revendas' },
        { value: 'concessionarias', label: 'Concessionárias' },
    ];

    const revendaNotificationOptions: Option[] = [
        { value: 'enviarPush', label: 'Push Notification' },
        { value: 'enviarEmail', label: 'E-mail' },
    ];

    const concessionariaNotificationOptions: Option[] = [
        { value: 'enviarEmail', label: 'E-mail' },
    ];

    const handleUserTypeChange = (option: Option) => {
        setUserType(option.value as 'revendas' | 'concessionarias');
    };

    const handleNotificationChange = (option: Option) => {
        setNotificationType(option.value as 'enviarPush' | 'enviarEmail');
    };


    useEffect(() => {
        if (userType === 'concessionarias') {
        setNotificationType('enviarEmail');
        }
    }, [userType]);



    const fetchUsers = async () => {
        try {
            const response = await getAllAdminUsers();
        
            if (response && Array.isArray(response)) {
                let filteredUsers = response;
    
                if (userTypeStatus === 'ativos') {
                    filteredUsers = response.filter(user => user.tagAtivo === '1');
                } else if (userTypeStatus === 'inativos') {
                    filteredUsers = response.filter(user => user.tagAtivo === '0');
                }
    
                const usersFormatted = filteredUsers.map((user) => ({
                    ...user,
                    fullName: `${user.nome}`, 
                }));
    
                setUsers(usersFormatted);
                setToEmail(usersFormatted.map(user => user.email));
                setName(usersFormatted.map(user => user.nome));
            }
    
        } catch (err) {
            console.error("Erro ao carregar usuários", err);
            setError("Erro ao carregar usuários.");
        } finally {
            setLoading(false);
        }
    };


    const fetchDealers = async () => {
        try {
            const response = await getAllAdminDealers();
    
            if (response && Array.isArray(response)) {
                let filteredDealers = response;
    
                if (userTypeStatus === 'ativos') {
                    filteredDealers = response.filter(Dealers => Dealers.tagAtivo === '1');
                } else if (userTypeStatus === 'inativos') {
                    filteredDealers = response.filter(Dealers => Dealers.tagAtivo === '0');
                }
    
                const DealersFormatted = filteredDealers.map((user) => ({
                    ...user,
                    fullName: user.fantasia, 
                }));
    
                setDealers(DealersFormatted);
                setToEmail(DealersFormatted.map(Dealers => Dealers.email));
                setName(DealersFormatted.map(Dealers => Dealers.fantasia));
            }
    
        } catch (err) {
            console.error("Erro ao carregar concessionárias", err);
            setError("Erro ao carregar concessionárias.");
        } finally {
            setLoading(false);
        }
    };
    
    
   



    useEffect(() => {

        if(userType !== 'revendas') {
        fetchDealers()
        }else{
            fetchUsers();
        }

    }, [userTypeStatus, userType])


    const handleUserTypeChangeStatus = (selectedOption: Option) => {
        setUserTypeStatus(selectedOption.value as 'todos' | 'ativos' | 'inativos'); 
    };
    
    
    const resetSendingState = () => {
        setIsSending(false);
        setTimeLeft(0);
        setEmailProgress(0);
        setEmailsSentCount(0);
        setTotalRecipients(0);
    };

    const clearForm = () => {
        setTitle('');
        setMessage('');
        setGreeting('');
        setFarewell('');
        setToEmail([]);
        setName([]);
    };

    const handlePushBroadcast = async () => {
        setIsSending(true);
        setEmailProgress(30);
        setEmailsSentCount(0);
        setTotalRecipients(0);

        try {
            const response = await postPushBroadcast({
                titulo: title,
                mensagem: message,
                status: userTypeStatus,
            });

            if (response?.status !== 200 || response.data?.success === false) {
                throw new Error(response?.data?.message || 'Erro ao enviar push');
            }

            const enviados = response.data?.enviados ?? 0;
            const total = response.data?.total ?? enviados;

            setEmailsSentCount(enviados);
            setTotalRecipients(total);
            setEmailProgress(100);
            setIsSending(false);
            setToast({ message: 'Push enviado com sucesso!', variant: 'success' });
            clearForm();
        } catch (error) {
            console.error('Erro ao enviar push:', error);
            setToast({ message: 'Erro ao enviar push', variant: 'error' });
            resetSendingState();
        }
    };

    const handleEmailBatches = async () => {
        const payload = { title, message };
        const batchSize = 100;
        const batchInterval = 5000;
        const delayBetweenBatches = 100000;

        const emailBatches: string[][] = [];
        const nameBatches: string[][] = [];

        for (let i = 0; i < toEmail.length; i += batchSize) {
            emailBatches.push(toEmail.slice(i, i + batchSize));
            nameBatches.push(name.slice(i, i + batchSize));
        }

        const totalBatches = emailBatches.length;
        let estimatedTime = totalBatches * delayBetweenBatches;

        setIsSending(true);
        setTimeLeft(estimatedTime);
        setEmailProgress(0);
        setEmailsSentCount(0);
        setTotalRecipients(toEmail.length);

        const interval = setInterval(() => {
            setTimeLeft(prevTime => Math.max(prevTime - 1000, 0));
        }, 1000);

        try {
            for (let i = 0; i < totalBatches; i++) {
                setTimeLeft(estimatedTime);

                const batchPayload = {
                    toEmails: emailBatches[i],
                    ...payload,
                    names: nameBatches[i],
                };

                try {
                    const response = await postComunication(batchPayload);

                    if (response?.status !== 200) {
                        throw new Error('Erro ao enviar e-mails');
                    }

                    estimatedTime -= delayBetweenBatches;
                    setTimeLeft(estimatedTime);
                    setEmailProgress(((i + 1) / totalBatches) * 100);
                    setEmailsSentCount(prev => prev + emailBatches[i].length);
                } catch (error) {
                    console.error('Erro ao enviar e-mails:', error);
                    setToast({ message: 'Erro ao enviar e-mails', variant: 'error' });
                    clearInterval(interval);
                    resetSendingState();
                    return;
                }

                if (i < totalBatches - 1) {
                    await new Promise(resolve => setTimeout(resolve, batchInterval));
                }
            }

            clearInterval(interval);
            setTimeLeft(0);
            setEmailProgress(100);
            setIsSending(false);
            setToast({ message: 'E-mails enviados com sucesso!', variant: 'success' });
            clearForm();
        } catch (error) {
            console.error('Erro ao enviar e-mails:', error);
            setToast({ message: 'Erro ao enviar e-mails', variant: 'error' });
            clearInterval(interval);
            resetSendingState();
        }
    };

    const handlePushEmail = async () => {
        if (!title || !message) {
            setToast({ message: 'Preencha todos os campos obrigatórios', variant: 'error' });
            return;
        }

        if (notificationType === 'enviarPush') {
            await handlePushBroadcast();
            return;
        }

        await handleEmailBatches();
    };
    
    
    
    
    
    
    
    


  return {
    loading,
    error,
    fetchUsers,
    handlePushEmail,
    setTitle,
    setMessage,
    setGreeting,
    setFarewell,
    farewell,
    greeting,  
    message,
    title,
    userTypeOptions,
    revendaNotificationOptions,
    concessionariaNotificationOptions,
    handleUserTypeChange,
    handleNotificationChange,
    userType,
    notificationType,
    handleUserTypeChangeStatus,
    userTypeStatus,
    userTypeStatusOptions,
    timeLeft,
    isSending,
    emailProgress,
    emailsSentCount,
    totalRecipients,
    toEmail
  };
};
